








































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'VenueSpaceBindSelector'

  resources:
    shipping_area_resource:
      resourceName: 'shipping_area'
      slug: 'suppliers/:supplierId/shipping_areas/:shippingArea.id/edit'
      fetch: false

    venues:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/venues'
      params:
        quick_list: true

  vue:
    props: ['shippingArea']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
    }

    data: ->
      selectedShippingAreaVenues: []
      selectedVenues: []

    computed:
      supplierId: -> @shippingArea?.top_org_id || @$store.member.supplier.id
      shippingAreaVenueIds: -> @shippingArea.venue_ids || []
      shippingAreaVenues: ->
        items = []
        for venue in (@venues || [])
          items.push venue if venue.id in @shippingAreaVenueIds
        items
      shippingAreaVenuesTableData: ->
        @shippingAreaVenues.map((venue) =>
          id: venue.id
          name: venue.venue_name
          street: venue.street
          city: venue.city
          state: venue.state
          data: venue
        )

      venuesTableData: ->
        for venue in (@venues || [])
          continue if venue.id in @shippingAreaVenueIds
          id: venue.id
          name: venue.venue_name
          street: venue.street
          city: venue.city
          state: venue.state
          data: venue

      optionsForBindSelector: ->
        title: 'Venues'
        description: 'Connect the venues this shipping address will serve'
        addExistingButtonText: 'Add Existing Venues'

    methods:
      hiShippingAreaVenuesSelectionChange: (venues) ->
        @selectedShippingAreaVenues = venues
      hiShippingAreaVenuesRowClick: (row) ->
        @$refs.shippingAreaVenuesTable.toggleRowSelection row
      hiUnbindShippingAreaVenue: (venue) ->
        @unbindVenuesFromShippingAreaTrigger [venue]
      hiUnbindSelectedShippingAreaVenues: ->
        @unbindVenuesFromShippingAreaTrigger @selectedShippingAreaVenues

      hiVenuesSelectionChange: (venues) ->
        @selectedVenues = venues
      hiVenuesRowClick: (row) ->
        @$refs.venuesTable.toggleRowSelection row
      hiBindVenue: (venue) ->
        @bindVenuesToShippingAreaTrigger [venue]
      hiBindSelectedVenues: ->
        @$refs.bindSelector.close()
        @bindVenuesToShippingAreaTrigger @selectedVenues

      bindVenuesToShippingAreaTrigger: (venues) ->
        payload = { venue_ids: venues.map((s) => s.id) }
        @triggerResource 'shipping_area_resource', 'bind_venues', payload
      onShippingAreaResourceBindVenues: (_, item) ->
        @$emit 'change', item

      unbindVenuesFromShippingAreaTrigger: (venues) ->
        payload = { venue_ids: venues.map((s) => s.id) }
        @triggerResource 'shipping_area_resource', 'unbind_venues', payload
      onShippingAreaResourceUnbindVenues: (_, item) ->
        @$emit 'change', item
        @$refs.shippingAreaVenuesTable?.clearSelection()

export default VueOptions.vue settings
